import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import axios from 'axios';
import $ from 'jquery';

import Constant from "../../utils/Constant";
import Header from "../common/Header";
import Footer from "../common/Footer";
import WC_Episode from "../section/WC_Episode";
import WC_Channel from "../section/WC_Channel";
import WC_Program from "../section/WC_Program";
import Cookies from "js-cookie";
import { encrypt, decrypt, key } from "../../utils/encryptiondecryption";

class Result extends React.Component{
    constructor() {
        super();
        //search
        this.callSearchApi = this.callSearchApi.bind(this);

        const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
        const decryptedText = decrypt(ciphertext, key);
        this.state = {
          auth: {
            device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
            phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
            user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
            mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
            package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
            subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
          },
    
            channels: {
                isLoaded: false,
                msg: 'Loading...',
                list: []
            },
            programs: {
                isLoaded: false,
                msg: 'Loading...',
                list: []
            },
            episodes: {
                isLoaded: false,
                msg: 'Loading...',
                list: []
            }
        }
    }
    componentDidMount(){
        if (!this.state.auth.user_id) {
            let baseUrl = window.location.protocol + "//" + window.location.host;
            if (window.location.href.match(new RegExp("^" + baseUrl + "/.+"))) {
              if (!(window.location.href.includes("bd.mjunoon.tv/?msisdn") || window.location.href.includes("bd.mjunoon.tv?msisdn") || window.location.href.includes("localhost:3000/?msisdn") || window.location.href.includes("/about-us") || window.location.href.includes("/privacy-policy") || window.location.href.includes("/terms-and-conditions") || window.location.href.includes("/contact-us") || window.location.href.includes("/faqs"))) {
                window.location.href = "http://he.mjunoon.tv:8080/register";
              }
            }
        }
        this.callSearchApi();
    }
    
    callSearchApi = () => {
        let classRef = this;
        let user_id = localStorage.getItem('user_id');
        let text = 'karachi';
        axios({
            method: 'POST',
            url: Constant.url+"search",
            data: {user_id: user_id,search:text}
        }).then(function (response) {
            if(response.data.code === 200){
                classRef.setState({
                    channels:{
                        isLoaded : true,
                        list: response.data.data.channels
                    },
                    programs:{
                        isLoaded : true,
                        list: response.data.data.programs
                    },episodes:{
                        isLoaded : true,
                        list: response.data.data.episodes
                    }
                })
            }
        }).then(function (response) {
            // console.log(response);
        });
    };
 
    
    render(){
        return(
           <div>
           <Header/> 
           <div class="search_box pad_left pad_right">
                <form class="">
                    <span class="search_icon" uk-search-icon></span>
                    <input class="" type="search" placeholder="Search mjunoon.tv..."></input>
                </form>
            </div>            
           <hr></hr>                         
           <div class="content_sec"> 
                {this.state.channels.isLoaded === true ?<WC_Channel name="Channels" data={this.state.channels.list}/>:''}
                <hr></hr>
                {this.state.programs.isLoaded === true ?<WC_Program name="Programs" data={this.state.programs.list}/>:''}                                
                <hr></hr>
                {this.state.episodes.isLoaded === true ?<WC_Episode name="Episodes" data={this.state.episodes.list}/>:''}
           </div>                     
           <Footer/>     
           </div>
        );
     }    
}

export default withRouter(Result);